import React, { useEffect, useState } from "react";
import { getUserDetails } from "./apis/userApis";
import Cookies from "js-cookie";
import { getCookiesSession, setCookiesSession } from "./apis/cookiesSession";

const Home = ({ children, setUserData }) => {
  const [config, setConfig] = useState({ Loading: true });
  useEffect(() => {
    const getUser = async () => {
      if (!getCookiesSession("userData")) {
        if (getCookiesSession("trueCounselUserData")) {
          try {
            const response = await getUserDetails();
            if (response?.success) {
              const user = { ...response.user };

              // Avoid setting state if data is already same

              setUserData(user);
              setCookiesSession("userData", JSON.stringify(user), 2);
              setCookiesSession("token", response.token, 2);
            }
          } catch (error) {}
        }
      } else {
        const storedUser = JSON.parse(getCookiesSession("userData"));
        if (storedUser) {
          setUserData(storedUser);
        }
      }
      setConfig({ Loading: false });
    };

    getUser();
  }, []); // `setUserData` is a stable function from `useState`, so no need to add it
  // ✅ Ensure re-run if setUserData changes

  return !config.Loading ? <>{children}</> : <p>Loading...</p>;
};

export default Home;
